import { getNGLFieldNames } from '@/components/documents/Foxit/FormMapping/FieldNameProviders/NGLFieldNameProvider'
import { useFormFillHelper } from '@/components/documents/Foxit/FormMapping/composables/FormFillHelper'
import { useIdentitySetup } from '@/components/documents/Foxit/FormMapping/composables/IdentityFields'
import { usePaymentSetup } from '@/components/documents/Foxit/FormMapping/composables/PaymentFields'

export default class NGLPaymentAuthorizationForm {
	private fieldNameProvider = getNGLFieldNames()
	private fields: (keyof typeof this.fieldNameProvider)[] = [
		'paymentModeAndAmountFields',
		'eftInitialPaymentFields',
		'eftOngoingPaymentFields',
		'creditCardPaymentFields',
		'directBillCheckboxFields',
		'insuredFullName',
		'purchaserFullName',
	]
	private unfilledFields = [
		'contractNumber',
		'singlePayMoneyOrderCheck',
		'multiPayMoneyOrderCheck',
		'initialPersonalAccountCheck',
		'initialBusinessAccountCheck',
		'ongoingPersonalAccountCheck',
		'ongoingBusinessAccountCheck',
		'creditCardVisaCheck',
		'creditCardMCCheck',
		'creditCardExpDate',
		'creditCardBillingAddress',
		'creditCardCity',
		'creditCardState',
		'creditCardZip',
		'purchaserSignature',
		'purchaserSignatureDate',
	]

	constructor(planHolderId: string) {
		const { identitySetup } = useIdentitySetup()
		const { paymentSetup } = usePaymentSetup()
		const { singlePayCCIsAllowed, setFieldNameProvider } = useFormFillHelper()

		setFieldNameProvider(this.fieldNameProvider)
		identitySetup(planHolderId, ['planHolder', 'funeralHome'])
		paymentSetup(planHolderId, ['paymentDetails'])

		// if singlePayCCIsAllowed is true, the single pay authorization form is being used which includes the singlePayCCCheck field
		if (singlePayCCIsAllowed()) {
			this.fields.push('singlePayCCCheck')
		}
	}

	getFormMappings() {
		const { formatFields, mapFields } = useFormFillHelper()
		const values = mapFields(this.fields)

		return formatFields(values)
	}
}
